export default "__VITE_ASSET__Lp8ItDJg__"